import BaseAPI from './base.api.service'

const resource = 'projects';
export default {
    async getMyManagerProjects() {
        return await BaseAPI.get(`${resource}/Managers`);
    },
    async saveProjectUsersAsAdmin(projectUsers) {
        return await BaseAPI.post(`${resource}/Users/Assign`, projectUsers);
    },
    async saveProjectUsers(projectUsers) {
        return await BaseAPI.post(`${resource}/Users`, projectUsers);
    },
    async getUserProjects(userId) {
        if (userId) {
            return await BaseAPI.get(`${resource}/Users/${userId}`);
        }
        else {
            return await BaseAPI.get(`${resource}/Users`);
        }
    },
    async getProjectModel(projectId) {
            return await BaseAPI.get(`${resource}/Users/project/${projectId}`);
    },
    async getProjects() {
        return await BaseAPI.get(`${resource}`);
    },
    async getActiveProjects() {
        return await BaseAPI.get(`${resource}/active`);
    },
    async getUserProjectsInUse(userId) {
        if (userId) {
            return await BaseAPI.get(`${resource}/Users/${userId}/inuse`);
        }
        else {
            return await BaseAPI.get(`${resource}/Users/inuse`);
        }
    },
    async getProject(projectId) {
        return await BaseAPI.get(`${resource}/${projectId}`);
    }
} 